// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"f188f8ac","511":"35c8d1de","970":"4f9a7fa8"}[chunkId] + ".chunk.css";
};